import api from '@/api'
import lodash from 'lodash'

const controller = {
  entity: 'equipment_resource',
  createOne: () => ({
    entity: controller.entity,
    author: '',
    type: '',
    meta: [],
    reg_date: new Date(),
    last_updated: new Date()
  }),
  updateControlFields: (content, context) => controller.updateLastUpdated(lodash.extend(content, {entity: controller.entity, reg_date: new Date(), author: context.rootState.user.data._id})),
  updateLastUpdated: (content) => lodash.extend(content, {last_updated: new Date()})
}

export default {
  namespaced: true,
  state: {
    list: [],
    selectedType: ''
  },
  mutations: {
    update (state, resource) {
      var o = lodash.find(state.list, {_id: resource._id})
      lodash.extend(o, resource)
    },
    clear (state) {
      state.list = []
    }
  },
  actions: {
    async load (context, type) {
      context.commit('clear')
      context.state.selectedType = type || context.state.selectedType
      if (context.state.selectedType === '') { return }
      const res = await api.postBIZ('/api/content/find', {selector: {entity: controller.entity, type: context.state.selectedType}, limit: 9999})
      context.state.list = res.data
    },
    async create (context, {resource, attachments}) {
      controller.updateControlFields(resource, context)
      var res = await api.putBIZ('/api/content', [{content: resource}])
      if (res.data.length < 1) { return }
      const {data: [{id, rev}]} = res
      lodash.extend(resource, {_id: id, _rev: rev})
      for (var i = 0; i < (attachments || []).length; i++) {
        await context.dispatch('uploadAttachment', {resource, attachment: attachments[i]})
      }
      await context.dispatch('load')
    },
    async delete (context, resource) {
      const uri = encodeURIComponent(`${resource._id}?rev=${resource._rev}`)
      await api.deleteBIZ(`/api/content?uri=${uri}`)
    },
    async updateAndSave (context, resource) {
      controller.updateControlFields(resource, context)
      const res = await api.putBIZ('/api/content', {uri: resource._id, content: resource})
      resource._rev = res.data._rev
      context.commit('update', resource)
    },
    async uploadAttachment (context, {resource, attachment}) {
      const query = encodeURIComponent(`${resource._id}/${attachment.name}?rev=${resource._rev}`)
      const fd = new FormData()
      fd.append('file', attachment)
      const {data: {rev}} = await api.putBIZ(`/api/content/attachment?uri=${query}`, fd)
      resource._rev = rev
    },
    async deleteAttachment (context, {resource, name}) {
      const query = encodeURIComponent(`${resource._id}/${name}?rev=${resource._rev}`)
      const {data: {rev}} = await api.deleteBIZ(`/api/content/attachment?uri=${query}`)
      resource._rev = rev
    },
    async downloadAttachment (context, {resource, name}) {
      const query = encodeURIComponent(`${resource._id}/${name}`)
      await api.downloadBIZ(`/api/content/attachment?uri=${query}`, {params: {filename: name}}, 'GET')
    },
    async getAttachment (context, {resource, name}) {
      const query = encodeURIComponent(`${resource._id}/${name}`)
      const res = await api.request(api.host_biz, `/api/content/attachment?uri=${query}`, {method: 'GET', responseType: 'blob'})
      return res
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/equipmentResource.js